import {Meter} from '@fantasmagames/core/src/update/Meter';
import {WinNumbers} from '@fantasmagames/slot/src/modules/winpresentation/WinNumbers';
import {Easing} from '@fantasmagames/core/src/tween/Easing';
import {CurrencyFormatter} from '@fantasmagames/core/src/utils/CurrencyFormatter';

export class WinMeter extends Meter {
	protected _winText: WinNumbers;
	protected _resolutionWidth: number;
	protected _resolutionPadding: number = 0;
	protected _includeCurrencySign: boolean;

	protected _autoFitWinNumbers: boolean = true;

	constructor(
		winText: WinNumbers,
		easing: Function = Easing.Linear.None,
		formatter?: CurrencyFormatter,
		includeCurrenySign: boolean = false,
		scale: number = 1,
	) {
		super(null, easing, formatter);
		this._winText = winText;
		this._includeCurrencySign = includeCurrenySign;
		this._winText.scale.set(scale);
	}

	public forceUpdate(): void {
		this.onUpdate();
	}

	protected onUpdate(): void {
		if (this._winText) {
			this._winText.showNumber(this.format(this._valueWrapper.value, this._includeCurrencySign));

			if (this._resolutionWidth && this._autoFitWinNumbers) {
				this.checkBounds();
			}
		}
	}

	protected checkBounds(): void {
		if (this._resolutionWidth) {
			this.fitWinTextToScreenSize();
		}
	}

	public fitWinTextToScreenSize(): void {
		const bounds = this._winText.getBounds();

		if (bounds.width / this._winText.scale.x > this._resolutionWidth) {
			if (this._winText.scale.y < 0) {
				this._winText.scale.set(this._resolutionWidth / (bounds.width / this._winText.scale.x), this._resolutionWidth / (bounds.width / this._winText.scale.x) * -1);
			} else {
				this._winText.scale.set(this._resolutionWidth / (bounds.width / this._winText.scale.x), this._resolutionWidth / (bounds.width / this._winText.scale.x));
			}
		}
	}

	protected format(value: number, includeCurrencySign: boolean = false): string {
		return this._formatter ? this._formatter.formatCurrency(value, includeCurrencySign) : value.toFixed(2);
	}

	public setTextAdditionalOffsets(numberOffset: number, comaAdditionalOffset: number): void {
		this._winText.additionalOffset = numberOffset;
		this._winText.comaAdditionalOffset = comaAdditionalOffset;
	}

	public set bigWinText(value: WinNumbers) {
		this._winText = value;
	}

	public set resolutionWidth(value: number) {
		this._resolutionWidth = value - this.resolutionPadding;
	}

	public set resolutionPadding(value: number) {
		this._resolutionPadding = value;
	}

	public get resolutionPadding(): number {
		return this._resolutionPadding;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/winpresentation/WinMeter.ts